import { DocumentLanguage } from "@/modules/patients/libs/document-languages"
import { BloodChemistry, Hematology } from "@/types/__generated__/union-types"

const BLOOD_CHEMISTRIES: Array<BloodChemistry> = [
  "ALBUMIN",
  "ALK_PHOSPHOTASE",
  "AMYLASE",
  "BILIRUBIN",
  "BLOOD_SUGAR",
  "CHLORIDE",
  "CHOLSTEROL",
  "CHOLSTEROL_HDL",
  "CK",
  "CRP",
  "GAMMA_GT",
  "GPT_ALAT",
  "GOT_ASAT",
  "URIC_ACID",
  "UREA",
  "HDL",
  "POTASSIUM",
  "CREATININE",
  "LDH",
  "SODIUM",
  "NT_PRO_BNP",
  "PHOSPHATE",
  "TRIGLYCERIDE",
  "TROPONIN_T",
]

const HEMATOLOGIES: Array<Hematology> = ["HAEMOGRAM_II", "HAEMOGRAM_V", "HBA1_C"]

const DOCUMENT_LANGUAGES: Array<{ value: DocumentLanguage; label: string }> = [
  { value: "GERMAN", label: "common.languageList.german" },
]

export { BLOOD_CHEMISTRIES, HEMATOLOGIES, DOCUMENT_LANGUAGES }
